export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pending-asset-register/:pageId',
        component: () => import('@/views/page/company/asset-register/pending-asset-register/List'),
        name: 'pending-asset-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-register/:pageId',
        component: () => import('@/views/page/company/asset-register/asset-register/List'),
        name: 'asset-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-register-add/:pageId',
        component: () => import('@/views/page/company/asset-register/asset-register/Add'),
        name: 'asset-register-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-assets/:pageId',
        component: () => import('@/views/page/company/asset-register/my-assets/List'),
        name: 'my-assets',
        meta: {
            requiresAuth: true
        }
    },
]